import React, { JSX } from "react";
import { RouteEnum } from "../common/enums/RouteEnum";
import { Link } from "react-router-dom";
import { Navigation } from "../common/components/general/Navigation";
import { Refresh } from "../common/svgs/Refresh";
import { useAppDispatch } from "./hooks";
import { SyncDataModalContainer } from "../modals/SyncDataModal/SyncDataModalContainer";
import { setIsSyncDataModalOpen } from "../modals/SyncDataModal/SyncDataModalSlice";
import { useLocalData } from "../common/hooks/useLocalData";
import { useNetworkStatus } from "../common/hooks/useNetworkStatus";
import { format } from "date-fns";

interface Props {
    children?: React.ReactNode;
}

export const AppWrapper = (props: Props): JSX.Element => {
    const dispatch = useAppDispatch();
    const { lastSync } = useLocalData();
    const { isOnline } = useNetworkStatus();

    return (
        <section className={"l-app"}>
            <aside className="l-app__menu">
                <div className="l-app__menu__content">
                    <Link to={RouteEnum.DASHBOARD} className="l-app__logo">
                        <img src="/images/bravilor-strips.svg" alt="logo" />
                    </Link>
                    <Navigation />
                    <div className="l-app__menu__footer">
                        <nav className="l-app__menu__nav">
                            <ul className="u-reset-ul">
                                <li>
                                    <div
                                        className={`l-app__menu__footer__link`}
                                        onClick={
                                            isOnline
                                                ? () =>
                                                      dispatch(
                                                          setIsSyncDataModalOpen(
                                                              true,
                                                          ),
                                                      )
                                                : undefined
                                        }
                                        style={{
                                            cursor: isOnline
                                                ? "pointer"
                                                : "not-allowed",
                                            opacity: isOnline ? 1 : 0.6,
                                        }}
                                    >
                                        <div
                                            className={`icon ${isOnline ? "online" : ""}`}
                                        >
                                            <Refresh />
                                        </div>
                                        <p>Last update</p>
                                        <p>
                                            {lastSync
                                                ? format(
                                                      new Date(lastSync),
                                                      "dd MMM yyyy",
                                                  )
                                                : "Never"}
                                        </p>
                                    </div>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </aside>
            <main className="l-app__content">{props.children}</main>
            <SyncDataModalContainer />
        </section>
    );
};
